/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim1DiagLeftIcon16Light } from './ArrowDim1DiagLeftIcon16Light';
import { ArrowDim1DiagLeftIcon16Regular } from './ArrowDim1DiagLeftIcon16Regular';
import { ArrowDim1DiagLeftIcon16Solid } from './ArrowDim1DiagLeftIcon16Solid';
import { ArrowDim1DiagLeftIcon20Light } from './ArrowDim1DiagLeftIcon20Light';
import { ArrowDim1DiagLeftIcon20Regular } from './ArrowDim1DiagLeftIcon20Regular';
import { ArrowDim1DiagLeftIcon20Solid } from './ArrowDim1DiagLeftIcon20Solid';
import { ArrowDim1DiagLeftIcon24Regular } from './ArrowDim1DiagLeftIcon24Regular';
import { ArrowDim1DiagLeftIcon24Solid } from './ArrowDim1DiagLeftIcon24Solid';
import { ArrowDim1DiagLeftIcon32Regular } from './ArrowDim1DiagLeftIcon32Regular';
import { ArrowDim1DiagLeftIcon64Regular } from './ArrowDim1DiagLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim1DiagLeftIcon16Light,
        regular: ArrowDim1DiagLeftIcon16Regular,
        solid: ArrowDim1DiagLeftIcon16Solid,
    },
    20: {
        light: ArrowDim1DiagLeftIcon20Light,
        regular: ArrowDim1DiagLeftIcon20Regular,
        solid: ArrowDim1DiagLeftIcon20Solid,
    },
    24: {
        regular: ArrowDim1DiagLeftIcon24Regular,
        solid: ArrowDim1DiagLeftIcon24Solid,
    },
    32: {
        regular: ArrowDim1DiagLeftIcon32Regular,
    },
    64: {
        regular: ArrowDim1DiagLeftIcon64Regular,
    },
};
export var ArrowDim1DiagLeftIcon = forwardRef('ArrowDim1DiagLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
